import React, { useState } from "react"

import Layout from "../components/layout"
import { BackgroundStructure, Glossary } from "../components"
import Seo from "../components/seo"

const GlossaryPage = () => {
  let languageStoredInLocalStorage = undefined
  if (typeof window !== "undefined") {
    languageStoredInLocalStorage = localStorage.getItem("language")
  }
  let [language, setLanguage] = useState(
    languageStoredInLocalStorage ? languageStoredInLocalStorage : "Deutsch"
  )

  return (
    <Layout
      language={language}
      parentSetLanguage={language => {
        setLanguage(language)
        storeLanguageInLocalStorage(language)
      }}
    >
      <Seo title="Glossar" />
      <BackgroundStructure />
      <Glossary language={language} />
    </Layout>
  )
}

function storeLanguageInLocalStorage(language) {
  if (typeof window !== "undefined") {
    localStorage.setItem("language", language)
  }
}

export default GlossaryPage
